export const regions = {
    auvergne_rhone_alpes: { 
        name: 'Auvergne-Rhône-Alpes'
    },
    bourgogne_franche_comte: {
        name: 'Bourgogne-Franche-Comté'
    },
    bretagne: {
        name: 'Bretagne'
    },
    centre_val_de_loire: {
        name: 'Centre-Val de Loire'
    },
    corse: {
        name: 'Corse'
    },
    grand_est: {
        name: 'Grand Est'
    },
    hauts_de_france: {
        name: 'Hauts-de-France'
    },
    ile_de_france: {
        name: 'Ile-de-France'
    },
    normandie: {
        name: 'Normandie'
    },
    nouvelle_aquitaine: {
        name: 'Nouvelle-Aquitaine'
    },
    occitanie: {
        name: 'Occitanie'
    },
    pays_de_loire: {
        name: 'Pays de la Loire'
    },
    paca: {
        name: 'Provence Alpes Côte d\'Azur'
    }
}